import { httpsCallable } from 'firebase/functions';
import { functions } from './firebaseService';
import { TesterPromotion } from '../types';

export async function submitTesterPromotion(opts: {
  url?: string;
  imageUrl?: string;
  description?: string;
}): Promise<{ ok: boolean; id: string }> {
  const callable = httpsCallable<typeof opts, { ok: boolean; id: string }>(functions, 'submitTesterPromotion');
  const result = await callable(opts);
  return result.data;
}

export async function approveTesterPromotion(opts: {
  promotion_id: string;
  action: 'approved' | 'rejected';
  reason?: string;
}): Promise<{ ok: boolean; ambassador: boolean; valid_until?: string }> {
  const callable = httpsCallable<typeof opts, { ok: boolean; ambassador: boolean; valid_until?: string }>(functions, 'approveTesterPromotion');
  const result = await callable(opts);
  return result.data;
}

export async function fetchTesterPromotions(status: string = 'pending'): Promise<{
  ok: boolean;
  promotions: TesterPromotion[];
}> {
  const callable = httpsCallable<{ status: string }, { ok: boolean; promotions: TesterPromotion[] }>(functions, 'fetchTesterPromotions');
  const result = await callable({ status });
  return result.data;
}

export async function sendPushToTesters(opts: {
  title: string;
  body: string;
}): Promise<{ ok: boolean; sent: number; failed: number; total: number }> {
  const callable = httpsCallable<typeof opts, { ok: boolean; sent: number; failed: number; total: number }>(functions, 'sendPushToTesters');
  const result = await callable(opts);
  return result.data;
}
